// extracted by mini-css-extract-plugin
export default {"italicTitle":"IwHphIp","count":"_zpc4DU"};